export enum EnumImageGenerationEntityType {
  products = "products",
  events = "events",
  news = "news",
}
